import { memo } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { AppState } from "@Store/index";
import useTranslationHook from "hooks/useTranslationHook";
import styles from "./CustomModeOfPayment.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import replaceAmberDomainInLinks from "@Utils/clientUtils/dangerouslySetInnerHtmlUtility/replaceAmberDomainInLinks";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

const CustomModeOfPayment = ({
  isModal = true,
  isDesktop = false,
}: {
  isModal?: boolean;
  isDesktop?: boolean;
}) => {
  const { t } = useTranslationHook();
  const { inventory } = useSelector(
    ({ propertyPageData, bookFormData }: AppState) => ({
      inventory: propertyPageData?.data || bookFormData?.data,
    }),
    shallowEqual,
  );

  const modeOfPaymentPolicy = inventory?.description?.find(
    (item: any) => item.name === "payment" && item.tag === "mode_of_payment",
  );

  if (!modeOfPaymentPolicy) return null;

  return (
    <>
      <div
        className={formatClassNames(
          styles.amenitiesContainerOuter,
          isModal && !isDesktop && styles.modalMobile,
        )}
      >
        <div className={styles.amenitiesMode}>
          {t("propertypage.components.installmentsection.custommodeofpayment.paymentmethods")}
        </div>
        <div className={styles.amenitiesSubDesc}>
          <div
            dangerouslySetInnerHTML={{
              __html: replaceAmberDomainInLinks(t(modeOfPaymentPolicy.value)),
            }}
            className={styles.subModeText}
          />
        </div>
      </div>
    </>
  );
};

export default wrapperHOC(memo(CustomModeOfPayment), {
  componentName: "CustomModeOfPayment-InstalmentSection-PropertyPage",
  showForChina: true,
});
